import React, { Component } from 'react'
import { withRouter } from 'react-router'
import PageNotFound from 'components/PageNotFound'
import reportCrash from './reportCrash'
import { IS_LOCALHOST } from 'config/consts'
import posthog from 'posthog-js'

class ErrorHandler extends Component {
	constructor(props) {
		super(props)
		this.state = { hasError: false }
	}

	static getDerivedStateFromProps({ location }, { hasError, locationKey }) {
		if(hasError && location.key !== locationKey) {
			return { hasError: false }
		}
		return null
	}

	sendReport(variables) {
		const { client } = this.props
		return client.mutate({
			mutation: reportCrash,
			variables
		})
	}

	componentDidCatch(error, info) {
		this.location = this.props.location
		this.setState({ hasError: true, locationKey: this.props.location.key })
		if(import.meta.env.PROD) {
			try {
				if(typeof posthog.captureException === 'function') {
					posthog.captureException(error, {
						$exception_handled: true,
						component_stack: info?.componentStack
					})
				} else {
					posthog.capture('$exception', {
						$exception_message: error?.message,
						$exception_type: error?.name,
						$exception_stack_trace: error?.stack,
						$exception_handled: true,
						component_stack: info?.componentStack
					})
				}
			} catch (captureError) {
				console.error('Failed to capture exception in PostHog', captureError)
			}
			const message = `${error.message}, Pathname: ${this.props.location.pathname}`
			this.sendReport({
				message,
				stacktrace: error.stack
			})
		}

	}

	goBack = () => {
		this.props.history.goBack()
	}


	render({ children } = this.props) {
		return this.state.hasError ?
			<PageNotFound type='ERROR'/> :
			children
	}
}

export default withRouter(ErrorHandler)
